import 'css-chunk:../components/form/checkbox/index.module.scss';export default {
  "svg": "_svg_1oioa_1",
  "active": "_active_1oioa_11",
  "checkbox_with_label": "_checkbox_with_label_1oioa_19"
};